import { Box, Typography } from "@mui/material";
import type { ReactNode } from "react";

interface SectionHeaderProps {
  title: ReactNode;
  leading?: ReactNode;
  actions?: ReactNode;
  trailing?: ReactNode;
}

/** Keeps section titles, export actions, and pagination within narrow panels. */
export function SectionHeader({ title, leading, actions, trailing }: SectionHeaderProps) {
  return (
    <Box
      data-section-header=""
      sx={{
        display: { xs: "grid", md: "flex" },
        gridTemplateColumns: "minmax(0, 1fr) auto",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1.5,
        mb: 3,
        minWidth: 0,
      }}
    >
      <Box
        sx={{
          display: { xs: "contents", md: "flex" },
          alignItems: "center",
          flexWrap: "wrap",
          gap: 1.5,
          minWidth: 0,
          gridColumn: 1,
          gridRow: 1,
        }}
      >
        <Typography
          component="h2"
          sx={{
            gridColumn: 1,
            gridRow: 1,
            minWidth: 0,
            fontSize: 20,
            fontWeight: 600,
            overflowWrap: "anywhere",
          }}
        >
          {title}
        </Typography>
        {leading && <Box sx={{ gridColumn: "1 / -1", gridRow: 2, minWidth: 0 }}>{leading}</Box>}
      </Box>
      {actions && (
        <Box
          data-pagination-region="top"
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "stretch", md: "center" },
            marginInlineStart: { md: "auto" },
            gridColumn: "1 / -1",
            gridRow: leading ? 3 : 2,
            gap: 1,
            minWidth: 0,
          }}
        >
          {actions}
        </Box>
      )}
      {trailing && (
        <Box
          data-section-trailing=""
          sx={{
            gridColumn: 2,
            gridRow: 1,
            display: "flex",
            alignItems: "center",
            justifySelf: "end",
            flexShrink: 0,
          }}
        >
          {trailing}
        </Box>
      )}
    </Box>
  );
}
